import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment/moment';
import { Modal } from 'reactstrap';
import DatePicker from 'react-datepicker';
import { monthDayYearWithSlashFormat } from '../../../../../constants/date';
import { daysDiffForMultipleJobs } from '../../../../../constants/jobs';
import Close from '../../../../common/ui/Close';
import FormActionButtons from '../../../../common/forms/FormActionButtons';
import Validator from '../../../../common/forms/Validator';
import ErrorMessage from '../../../../common/forms/ErrorMessage';

export default class CreateEventModal extends Validator {
  static propTypes = {
    isOpen: PropTypes.bool.isRequired,
    jobStartDate: PropTypes.object,
    closeModal: PropTypes.func.isRequired,
    submitCreateEvent: PropTypes.func.isRequired
  };

  state = {
    name: '',
    start_date: null,
    end_date: null
  };

  validationRules = {
    name: { required: true },
    start_date: { required: true },
    end_date: { required: true }
  };

  handleChangeName = event => {
    this.setState({
      name: event.target.value
    });
  };

  handleChangeDate = (fieldName, date) => {
    this.setState({
      [fieldName]: date
    });
  };

  clearForm = () => {
    this.setState({
      name: '',
      start_date: null,
      end_date: null
    });
  };

  closeModal = () => {
    this.clearForm();
    this._resetErrors();
    this.props.closeModal();
  };

  _validate = () => {
    return this.validate(this.validationRules, this.state);
  };

  handleSubmitEventForm = e => {
    e.preventDefault();
    this._resetErrors();
    if (!this._validate()) {
      return;
    }
    const { name, start_date, end_date } = this.state;
    this.props.submitCreateEvent({
      name,
      start_date,
      end_date
    }).then(() => this.closeModal());
  };

  render () {
    const { isOpen, closeModal, jobStartDate } = this.props;
    const { name, start_date, end_date } = this.state;
    let minStartDate = end_date ? end_date.clone().subtract(daysDiffForMultipleJobs, 'days') : moment();
    let maxStartDate = end_date;
    let minEndDate = start_date || moment();
    let maxEndDate = start_date && start_date.clone().add(daysDiffForMultipleJobs, 'days');
    if (jobStartDate) {
      minStartDate = end_date ? end_date.clone().subtract(daysDiffForMultipleJobs, 'days') : jobStartDate.clone().subtract(daysDiffForMultipleJobs, 'days');
      maxStartDate = jobStartDate;
      minEndDate = jobStartDate;
      maxEndDate = start_date ? start_date.clone().add(daysDiffForMultipleJobs, 'days') : jobStartDate.clone().add(daysDiffForMultipleJobs, 'days');
    }
    const errors = this.validationErrors;
    return (
      <Modal isOpen={isOpen}>
        <div className='modal-header flex-wrap'>
          <div className='modal-title'>Create New Event</div>
          <Close onClick={closeModal} />
        </div>
        <form className='modal-body' onSubmit={this.handleSubmitEventForm}>
          <div className='form-group'>
            <label className='label' htmlFor='new-event-name-input'>Name</label>
            <input
              id='new-event-name-input'
              className='input'
              value={name}
              onChange={this.handleChangeName}
            />
            <ErrorMessage errorText={errors.name} />
          </div>
          <div className='form-group'>
            <label className='label' htmlFor='new-event-start-input'>Start Date</label>
            <div className='input-picker-box'>
              <DatePicker
                id='new-event-start-input'
                className='input-picker'
                dateFormat={monthDayYearWithSlashFormat}
                onChange={date => this.handleChangeDate('start_date', date)}
                selected={start_date}
                minDate={minStartDate}
                maxDate={maxStartDate}
                dropdownMode='select'
              />
            </div>
            <ErrorMessage errorText={errors.start_date} />
          </div>
          <div className='form-group'>
            <label className='label' htmlFor='new-event-end-input'>End Date</label>
            <div className='input-picker-box'>
              <DatePicker
                id='new-event-end-input'
                className='input-picker'
                dateFormat={monthDayYearWithSlashFormat}
                onChange={date => this.handleChangeDate('end_date', date)}
                selected={end_date}
                minDate={minEndDate}
                maxDate={maxEndDate}
              />
            </div>
            <ErrorMessage errorText={errors.end_date} />
          </div>
          <FormActionButtons onClickCancel={this.closeModal} submitTitle='Create' />
        </form>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/app/createJob/createJob/ChooseEmployerEventStep/CreateEventModal.js